import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=9c518a4c"
import script from "./_id.vue?vue&type=script&setup=true&lang=ts"
export * from "./_id.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkDetailHeader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkDetailHeader.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CreatorShopCollectionShareButton: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/collection/ShareButton.vue').default,CreatorShopProductSetProductTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/product-set/ProductSetProductTile.vue').default,LtkGrid: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkGrid.vue').default,CContainer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CContainer.vue').default})
